import React, { useState, useRef, useEffect } from "react";
import "./Corporate.css";
import Header from "Components/Header/Header";
import Footer from "Components/Footer/Footer";
import dot3 from "Assests/Images/dot3.svg";
import { isValidPhoneNumber } from "libphonenumber-js";
import { useDispatch, useSelector } from "react-redux";
import { setAlert } from "../../Redux/Actions/alert.action";
import httpPathName from "Global/Config/Config";
import { ReactComponent as CartIcon } from "Assests/Icons/cartIcon.svg";
import { bookNowApi } from "API/post.api";
import { setAuthenticationModel } from "../../Redux/Actions/model";
import { useNavigate } from "react-router";
import diagnostics from "Assests/Images/diagnostics.png";
import Spinner from "react-bootstrap/Spinner";
// import useMetaTags from "Components/Hooks/useMetaTags";
import MetaDetails from "Components/MetaDetails/MetaDetails";
import partnerWithUs from "Assests/Images/partnerWithUs.png";
import Wanner from "Components/Wnner/Wanner";

const nav = [
  "Annual Physical Examination",
  "Pre-Employment Checkup",
  "Preventive Health Packages",
  "OncoNed",
];

const Corporate = () => {
 

  // Using Custom Hook for adding Meta Title and Meta Description for Page
  // useMetaTags("Our corporate healthcare solutions elevate healthcare standards","Explore our corporate solutions designed for optimized healthcare of your employees. Collaborate with us to boost healthcare standards within your organization.")

  

  function section1() {
    return (
      <>
        <div className="section1-warpper">
          <h1>Wellness Packages</h1>
          <p>
            Stress is good as it keeps oneself busy and help to reach the goal.
            But when stress becomes routine part of the life, it could affect
            one’s health severely. Work pressure can lead to chronic diseases
            like diabetes, insomnia, obesity, hypertension and even heart
            disease as well. It is observed that people who are under stress
            often move towards unhealthy habits like munching on junk food, drug
            abuse, alcohol, cigarettes etc. Being pathology specialists, we
            understand the need and to bridge this gap, we offer services that
            are flexible and customized to suit the requirements of our client.
            These health packages are comprehensive and preventive, which helps
            to monitor and takes care of well-being of employee. As it is
            rightly said “Health is wealth”, many organizations are taking
            special care for their employees, by introducing corporate wellness
            programs. This is a win-win situation for both the employers and the
            employees. This helps the company to monitor the health of its
            workforce and avoid absenteeism and underperformance along with
            employee retention. On the other hand employees contribute to the
            company in a productive and efficient manner.
          </p>
        </div>
      </>
    );
  }

  function section2() {
  }

  function section3() {
  }

  return (
    <>
      <MetaDetails
        title="Our corporate healthcare solutions elevate healthcare standards"
        description="Explore our corporate solutions designed for optimized healthcare of your employees. Collaborate with us to boost healthcare standards within your organization."
      />

      <Header />
      <div className="corporate">
        <Wanner title="Corporate" image={partnerWithUs} dot={false} />

        {/* <div className="partnerTitlemiddle">
          <h1>Corporate</h1>
          <img src={dot3} alt="dot3" />


        </div> */}
        <div className="section1">{section1()}</div>
        <div className="section2">{section2()}</div>
        {/* <div className="section3">{section3()}</div> */}
        

      </div>
      <Footer />
    </>
  );
};

export default Corporate;
